import React, { useState } from 'react'
import { Doughnut } from "react-chartjs-2";
import clock from "../../images/purple-clock.png";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
} from "chart.js";

import "./DoughnutChart.css";   
ChartJS.register(ArcElement, Tooltip);


function DoughnutChart({ value = 0 } ) {

  const data = {
    datasets: [
      {
        data: [value, 100 - value],
        backgroundColor: ["#fff", "#9c6ea7"],
        borderWidth: 0,
        cutout: "95%",
        borderRadius: 0,
circumference: 360,
rotation: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: { enabled: false },
    },
  };


const endDotPlugin = {
  id: "endDot",
  afterDatasetDraw(chart) {
    const { ctx } = chart;
    const meta = chart.getDatasetMeta(0);

    if (!meta?.data?.length) return;

    const arc = meta.data[0];

    const angle = arc.startAngle + arc.circumference;

    // 👇 Center of ring thickness
    const radius = (arc.outerRadius + arc.innerRadius) / 2;

    const centerX = arc.x;
    const centerY = arc.y;

    const dotX = centerX + Math.cos(angle) * radius;
    const dotY = centerY + Math.sin(angle) * radius;

    ctx.save();
    ctx.beginPath();
    ctx.arc(dotX, dotY, 5, 0, Math.PI * 2); // adjust size if needed
    ctx.fillStyle = "#ffffff";
    ctx.fill();
    ctx.restore();
  },
};




  return (
   <div className="circular-chart-wrapper">
      <Doughnut data={data} options={options} plugins={[endDotPlugin]} />
      <div className="circular-center">
        <h2>{value}%</h2>
        <span>complete</span>
        <img src={clock} alt="" />
      </div>
    </div>
  )
}

export default DoughnutChart